import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

interface Slide {
  name: string;
  designation: string;
  description: string;
  image: string;
}

interface SwipperProps {
  slidesData: Slide[];
  uniqueId: string; // Changed to uniqueId for clarity
}

const UserTestimonials: React.FC<SwipperProps> = ({ slidesData, uniqueId }) => {
  const pagination = {
    clickable: true,
  };

  // Unique selectors based on uniqueId
  const nextButtonSelector = `.swiper-button-next-${uniqueId}`;
  const prevButtonSelector = `.swiper-button-prev-${uniqueId}`;

  return (
    <>
      <Swiper
        className="multipleSwipper testimonialSlider pb-5"
        pagination={pagination}
        navigation={{
          nextEl: nextButtonSelector,
          prevEl: prevButtonSelector,
        }}
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          480: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
        }}
        modules={[Pagination, Navigation]}
        spaceBetween={20}
        slidesPerView={3}
        onSlideChange={() => {}}
        onSwiper={(swiper: any) => {}}
      >
        {slidesData.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="userTestimonialCard">
              <div className="imgContMain">
                <div className="imgCont"></div>
                <img src="/assets/imgs/user1.png" alt="" />
              </div>
              <p>
                Aenean commodo ligula egget dolor. Aenean massa. Cum sociis
                natoque penatibus et magnis dis parturient montes, nascetur
                ridiculus mus.
              </p>
              <h2>Olivia Green</h2>
              <span>CEO, Company</span>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div
        className={`swiper-button swiper-button-prev-custom swiper-button-prev-${uniqueId}`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="42"
          height="16"
          viewBox="0 0 42 16"
          fill="none"
        >
          <path
            d="M0.292893 7.29289C-0.0976295 7.68341 -0.0976296 8.31658 0.292892 8.7071L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41422 8L8.07107 2.34314C8.46159 1.95262 8.46159 1.31945 8.07107 0.928929C7.68054 0.538405 7.04738 0.538405 6.65685 0.928929L0.292893 7.29289ZM42 7L1 7L1 9L42 9L42 7Z"
            fill="#231F20"
          />
        </svg>
      </div>

      <div
        className={`swiper-button swiper-button-next-custom swiper-button-next-${uniqueId}`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="42"
          height="16"
          viewBox="0 0 42 16"
          fill="none"
        >
          <path
            d="M41.7071 8.70711C42.0976 8.31658 42.0976 7.68342 41.7071 7.29289L35.3431 0.928932C34.9526 0.538408 34.3195 0.538408 33.9289 0.928932C33.5384 1.31946 33.5384 1.95262 33.9289 2.34315L39.5858 8L33.9289 13.6569C33.5384 14.0474 33.5384 14.6805 33.9289 15.0711C34.3195 15.4616 34.9526 15.4616 35.3431 15.0711L41.7071 8.70711ZM0 9H41V7H0V9Z"
            fill="white"
          />
        </svg>
      </div>
    </>
  );
};

export default UserTestimonials;
